// ©2024 Austin App House. All rights reserved.
import React from 'react';
import { MDBRow } from 'mdbreact';
import { useState } from 'react';
import axios from 'axios';
import Editor from '../../layout/editor';
import moment from 'moment';

const NotesSection = ({
  notes = [],
  contractorId
}) => {
  const [desc, setDesc] = useState();
  const [notesToShow, setNotesToShow] = useState(notes);

  const handleSave = async () => {
    setDesc('')
    await axios.post('/api/contractor/addNote', {
      contractorId,
      description: desc,
    }).then(res => {
      setNotesToShow(prev => [...prev, res.data.note])
    })
  }
  return (
    <div className="field_col">
      {notesToShow.map((note, index) => (
        <div key={index} className='ml-2'>
          <span className='mr-3'>{note.createdAt && moment(note.createdAt).isValid ? moment(note.createdAt).format('MM/DD/YYYY') : ''}</span>
          <div dangerouslySetInnerHTML={{__html: 
          `${note.from}: <div class="ml-2"> ${note.description}</div>`
          }} />
        </div>
      ))}
      <label>Add new note</label>
      <Editor
        data={desc}
        onChange={desc => setDesc(desc)}
      />
      <div className="popup_footer popup_footer--inline">
        <button type="button" className="dashboard-btn dashboard-btn--primary" onClick={() => handleSave()}>
          Save
        </button>
      </div>
    </div>
  )
};

export default NotesSection;
